// extracted by mini-css-extract-plugin
module.exports = {"profilesContainer":"ourTeam_profilesContainer__78TOH"};